<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title
        class="headline py-0"
        style="bottom:-15px; position:relative;"
      >
        <v-row justify="space-between" align="center" no-gutters>
          <v-col cols="2"></v-col>
          <v-col class="text-center title" cols="8" v-text="title"></v-col>
          <v-col class="text-right" cols="2">
            <v-btn text icon color="grey" large @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-0">
        <canvas id="canvas"></canvas>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import QRCode from "qrcode";

export default {
  data: () => ({
    dialog: false,
    clinic: {},
    qrcode: "",
    title: ""
  }),
  methods: {
    async showPetQrcode(selectId) {
      this.title = "寵物大頭照行動條碼";
      this.qrcode = `line://app/${this.clinic.liff_QRcode}?liffId=${this.clinic.liff_QRcode}&botId=${this.clinic.botId}&action=setAvatar&selectId=${selectId}`;
      console.log("qrcode:" + this.qrcode);
      this.drawQrcode();
    },
    showReportQrcode(reportTitle, reportId) {
      this.title = `${reportTitle}報告行動條碼`;
      this.qrcode = `line://app/${this.clinic.liff_QRcode}?liffId=${this.clinic.liff_QRcode}&botId=${this.clinic.botId}&action=setReport&selectId=${reportId}`;
      console.log("qrcode:" + this.qrcode);
      this.drawQrcode();
    },
    async drawQrcode() {
      this.dialog = true;
      await this.$nextTick();

      QRCode.toCanvas(document.getElementById("canvas"), this.qrcode, {
        width: 400,
        height: 400
      });
    },
    async getClinic() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/clinicData/${this.$my.getClinic()}`
      );
      this.clinic = response.data;
      console.log("this.clinic:" + JSON.stringify(this.clinic));
    }
  },
  async mounted() {
    this.getClinic();
  }
};
</script>
